// hooks/useDashboardData.js - UPDATED
import { useState, useEffect, useCallback } from 'react';
import api from '../utils/api';
import { API_CONFIG } from '../utils/apiConfig';

const useDashboardData = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      
      const response = await api.post(API_CONFIG.DASHBOARD.DASHBOARD, {});

      if (response.data.success) {
     
        setData(response.data.data);
      } else {
        setError(response.data.error || 'Failed to fetch dashboard data');
      }
    } catch (err) {
      console.error('Dashboard data fetch error:', err);
      
      if (err.response?.status === 403) {
        setError('Session issue. Please refresh the page.');
      } else if (err.response?.status === 401) {
        setError('Please login again.');
      } else if (err.response?.data?.error) {
        setError(err.response.data.error);
      } else {
        setError('Failed to load dashboard data');
      }
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const refresh = useCallback(() => {
    fetchData();
  }, [fetchData]);

  return { 
    data, 
    loading, 
    error, 
    refresh,
    company: data?.company || {},
    account: data?.account || {},
    brandData: data?.brandData || {},
    banks: data?.banks || [],
    hasPin: data?.hasPin || false,
    PreRegBalance: data?.PreRegBalance || 0
  };
};

export default useDashboardData;